<template>
    <div class="richtext-input">
        <div v-if="!disableEdit" style="border: 1px solid #ccc;">
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
            />
            <Editor
                style="height: 300px; overflow-y: hidden;resize: vertical;"
                v-model="hereValue"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
            />
        </div>
        <div v-else v-html="value"></div>
    </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { i18nChangeLanguage } from '@wangeditor/editor'
import { fileToBase64 } from '@/utils'

export default {
    name: 'RichtextInput',
    components: { Editor, Toolbar },
    props: {
        value: {
            type: String,
            default: ''
        },
        onChange: {
            type: Function,
            default: () => {}
        },
        disableEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {return {
        editor: null,
        hereValue: '',
        editorConfig: { 
            maxLength: 3000,
            MENU_CONF: {
                uploadImage: { ...this.onUploadImage() }
            }
        },
        toolbarConfig: { 
            excludeKeys: [
                'group-more-style',
                'emotion',
                'group-video',
                'group-image',
                'insertTable',
                'justifyJustify',
                'fullScreen'
            ]
        },
        mode: 'default', // or 'simple'
    }},
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    methods: {
        onCreated(editor) {
            
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            this.hereValue = this.value

            i18nChangeLanguage({
                zh: 'zh-CN',
                en: 'en'
            }[this.$i18n.locale])
        },
        change(e) {
            this.onChange && this.onChange(e)
        },
        onUploadImage: () => ({
            async customUpload(file, insertFn) {                   // JS 语法
                const base64 = await fileToBase64(file)
                // file 即选中的文件
                // 自己实现上传，并得到图片 url alt href
                // 最后插入图片
                //  
                insertFn(base64, file.name, '')
            }
        })
    },
    watch: {
        value(v) {
            this.hereValue = v
        },
        hereValue(v) {
            this.$emit('update:value', v)
            this.change(v)
        },
        '$i18n.locale': function(v) {
            i18nChangeLanguage({
                zh: 'zh-CN',
                en: 'en'
            }[v])
            this.editor.updateView()
        }
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.w-e-menu-tooltip-v5:after,
.w-e-menu-tooltip-v5:before {
    display: none;
}
</style>
